// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADMIN_USER = "Modr\u00fd kon\u00edk";
export const AUTHOR = "autor";
export const BLOGPOST_COMMENT_DELETED_BY_AUTHOR = "Autor koment\u00e1\u0159 smazal";
export const BLOGPOST_COMMENT_DELETED_BY_SOMEONE = "Koment\u00e1\u0159 byl odstran\u011bn\u00fd";
export const BLOGS_CANT_SEE_ANSWER = "P\u0159idej sout\u011b\u017en\u00ed koment\u00e1\u0159 a uvid\u00ed\u0161 koment\u00e1\u0159e ostatn\u00edch";
export const COMMENT_DELETED_BY_ADMIN = "Odpov\u011b\u010f byla odstran\u011bn\u00e1";
export const COMMENT_DELETED_BY_AUTHOR = "Autor odpov\u011b\u010f smazal";
export const FORUM_CANT_SEE_ANSWER = "P\u0159idej sout\u011b\u017en\u00ed odpov\u011b\u010f a uvid\u00ed\u0161 odpov\u011bdi ostatn\u00edch\n";
export const GROUP_COMMENT_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1\u0161en\u00ed koment\u00e1\u0159e";
export const SHOW = "Zobraz";
